/** @format */
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronDown
} from '@dsg-tech/homefield-angular-icons';

import { AccordionComponent } from './accordion.component';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [AccordionComponent],
	imports: [CommonModule, HomefieldIconLibraryModule],
	exports: [AccordionComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AccordionModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconChevronDown]);
	}
}
